import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./VerificationNew.module.css";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import Cookies from "js-cookie";
import { url } from "../../../../../../../../../App";
import { toast, ToastContainer } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import "../../../../../../../../../assets/Nirmala-normal";
import { useParams } from "react-router-dom";

const VerificationNew = () => {
  const { loanid } = useParams();
  const loanID = loanid;
  const { borrowerData } = useBorrowerContext();
  const loan = borrowerData?.loan?.find(
    (item) => String(item.loan_id) === String(loanID)
  );
  const [open, setOpen] = React.useState(false);
  const [activeTab, setActiveTab] = useState("App");
  const [panNo, setPanNo] = useState("");
  const [dob, setDob] = useState("");
  const [name, setName] = useState("");
  const [voterId, setVoterId] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [customerLoanId, setCustomerLoanId] = useState("");
  const [bankAccNo, setBankAccNo] = useState("");
  const [beneficiaryName, setBeneficiaryName] = useState("");
  const [bankIfsc, setBankIfsc] = useState("");
  const [bankName, setBankName] = useState("");
  const [requestor, setRequestor] = useState("");
  const [aadhaarNo, setAadhaarNo] = useState("");
  const [dlNo, setDlNo] = useState("");
  const [infoData, setInfoData] = useState(null);
  const [visible, setvisible] = useState(false);
  const [decryptButtonVisible, setDecryptButtonVisible] = useState(false);
  const [bankAccNoCollection, setBankAccNoCollection] = useState("");
  const [beneficiaryNameCollection, setBeneficiaryNameCollection] = useState("");
  const [bankIfscCollection, setBankIfscCollection] = useState("");
  const [bankNameCollection, setBankNameCollection] = useState("");
  const [activeAccountType, setActiveAccountType] = useState("DISBURSEMENT");
  const [numberOfCoapplicants, setNumberOfCoapplicants] = useState("");
  const [filteredCoapplicants, setFilteredCoapplicants] = useState([]);
  const [expandedAccordion, setExpandedAccordion] = useState(false);
  const [sourcePhone, setSourcePhone] = useState("");

  const [panStatusData, setPanStatusData] = useState({
    "Verification Platform": "",
    "PAN ": "",
    "PAN Status ": "",
    "Category ": "",
    "Registered Name / Name Match ": "",
    "Name on PAN Card ": "",
    "DOB / Date of birth match ": "",
    "Aadhaar PAN Link Status ": "",
    "Checked On ": "",
  });

  const [voterIdStatusData, setVoterIdStatusData] = useState({
    "Verification Platform": "",
    "VOTER ID ": "",
    "Name ": "",
    "Polling Station Name ": "",
    "Assembly Constituency Name ": "",
    "District ": "",
    "State ": "",
    "Checked On ": "",
  });

  const [bankStatusData, setBankStatusData] = useState({
    "Platform ": "",
    Status: "",
    "Borrower Disbursement Bank Account No": "",
    "Borrower Disbursement Bank Account Name as Provided": "",
    "Borrower Name as per Bank Records ": "",
    "Borrower Disbursement Bank Name ": "",
    "Borrower Disbursement Bank Branch Name ": "",
    "Borrower Disbursement Bank IFSC Code ": "",
    "Checked On ": "",
  });

  const [bankStatusDataCollection, setBankStatusDataCollection] = useState({
    "Platform ": "",
    Status: "",
    "Borrower Collection Bank Account No": "",
    "Borrower Collection Bank Account Name as Provided": "",
    "Borrower Name as per Bank Records ": "",
    "Borrower Collection Bank Name ": "",
    "Borrower Collection Bank Branch Name ": "",
    "Borrower Collection Bank IFSC Code ": "",
    "Checked On ": "",
  });

  const [aadhaarStatusData, setaadhaarStatusData] = useState({
    "Verification Platform": "",
    "AADHAAR No (Encrypted/Masked) ": "",
    "Name ": "",
    "Address ": "",
    "Gender ": "",
    DOB: "",
    Status: "",
    photo_link: "",
  });

  const [dlStatusData, setDlStatusData] = useState({
    "Verification Platform": "CASHFREE",
    "DL No. ": "",
    "Status ": "",
    "Name ": "",
    DOB: "",
    "DL Issue Date ": "",
    "Vehicle Class ": "",
    "Valid Till ": "",
    "District ": "",
    "State ": "",
    "Checked On ": "",
  });

  const EMAIL = Cookies.get("Email");
  const TOKEN = Cookies.get("Token");

  // console.log(borrowerData);
  // const numberOfCoapplicants = borrowerData.coapplicant.length;
  // console.log(numberOfCoapplicants);

  useEffect(() => {
    if (loanID) {
      const filtered = borrowerData.coapplicant.filter(
        (coapplicant) => coapplicant.coapplicant_loan_id === loanID
      );
      setNumberOfCoapplicants(filtered.length);
      setFilteredCoapplicants(filtered);
    } else {
      setNumberOfCoapplicants(0);
      setFilteredCoapplicants([]);
    }
  }, [loanID, borrowerData.coapplicant]);

  const fetchedLoanDetails = borrowerData.loan;
  const foundLoan = fetchedLoanDetails.find((item) => item.loan_id === loanID);
  const [isDisbursed, setIsDisbursed] = useState(false);

  useEffect(() => {
    if (loanID) {
      setIsDisbursed(foundLoan?.loan_status === "DISBURSED");
    }
    //eslint-disable-next-line
  }, [foundLoan]);

  const fetchPanStatus = async (id) => {
    console.log(id);

    if (!id) {
      setPanStatusData((prevStatus) => ({
        ...prevStatus,
        "Verification Platform": "",
        "PAN ": "PAN NOT PROVIDED",
        "PAN Status ": "",
        "Category ": "",
        "Registered Name / Name Match ": "",
        "Name on PAN Card ": "",
        "DOB / Date of birth match ": "",
        "Aadhaar PAN Link Status ": "",
        "Checked On ": "",
      }));
    } else {
      try {
        const checkStatus = await axios.post(
          url + "/borrower/fetchPanVerification",
          {
            email: EMAIL,
            token: TOKEN,
            panNo: id,
          }
        );

        // console.log(checkStatus.data);
        if (checkStatus.data.auth === true) {
          setPanStatusData((prevStatus) => ({
            ...prevStatus,
            "Verification Platform": checkStatus.data.message.platform ?? "",
            "PAN ": checkStatus.data.message.panNumber ?? "",
            "PAN Status ": checkStatus.data.message.status ?? "",
            "Category ": checkStatus.data.message.category ?? "",
            "Registered Name / Name Match ":
              checkStatus.data.message.nameAsPerPanMatch ?? "",
            "Name on PAN Card ": checkStatus.data.message.nameOnPanCard ?? "",
            // "DOB / Date of birth match ": checkStatus.data.message.panDobMatch ?? checkStatus.data.message.panDob ?? "",
            // "DOB / Date of birth match ": checkStatus.data.message.panDob ? checkStatus.data.message.panDob : "",
            "DOB / Date of birth match ":
              checkStatus.data.message.panDobMatch &&
              checkStatus.data.message.panDobMatch !== "N/A"
                ? checkStatus.data.message.panDobMatch
                : checkStatus.data.message.panDob ?? "",
            "Aadhaar PAN Link Status ":
              checkStatus.data.message.aadharSeedingStatus ?? "",
            "Checked On ":
              formattedDate(checkStatus.data.message.checkedOn) ?? "",
          }));
        } else {
          // toast.error('PAN Data not fetched');
          setPanStatusData((prevStatus) => ({
            ...prevStatus,
            "Verification Platform": "",
            "PAN ": id,
            "PAN Status ": "",
            "Category ": "",
            "Registered Name / Name Match ": "",
            "Name on PAN Card ": "",
            "DOB / Date of birth match ": "",
            "Aadhaar PAN Link Status ": "",
            "Checked On ": "",
          }));
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const fetchVoterStatus = async (id) => {
    console.log(id);

    if (!id) {
      setVoterIdStatusData((prevStatus) => ({
        ...prevStatus,
        "Verification Platform": "",
        "VOTER ID ": "VOTERID NOT PROVIDED",
        "Name ": "",
        "Polling Station Name ": "",
        "Assembly Constituency Name ": "",
        "District ": "",
        "State ": "",
        "Checked On ": "",
      }));
    } else {
      try {
        const checkStatus = await axios.post(
          url + "/borrower/fetchVoterIdVerification",
          {
            email: EMAIL,
            token: TOKEN,
            voterId: id,
          }
        );

        // console.log(checkStatus.data);
        if (checkStatus.data.auth === true) {
          setVoterIdStatusData((prevStatus) => ({
            ...prevStatus,
            "Verification Platform": checkStatus.data.message.platform ?? "",
            "VOTER ID ": checkStatus.data.message.epicNo ?? "",
            "Name ": checkStatus.data.message.name ?? "",
            "Polling Station Name ":
              checkStatus.data.message.pollingStationName ?? "",
            "Assembly Constituency Name ":
              checkStatus.data.message.assemblyConstituencyName ?? "",
            "District ": checkStatus.data.message.districtName ?? "",
            "State ": checkStatus.data.message.stateName ?? "",
            "Checked On ":
              formattedDate(checkStatus.data.message.checkedOn) ?? "",
          }));
        } else {
          // toast.error('VOTERID Data not fetched');
          setVoterIdStatusData((prevStatus) => ({
            ...prevStatus,
            "Verification Platform": "",
            "VOTER ID ": id,
            "Name ": "",
            "Polling Station Name ": "",
            "Assembly Constituency Name ": "",
            "District ": "",
            "State ": "",
            "Checked On ": "",
          }));
        }
      } catch (err) {
        console.log(err);
      }
    }
  };
  console.log(loan);

  const fetchBankStatus = async (id, ifsc, acNo, bank) => {
    console.log(id, ifsc);

    if (!id || !ifsc || !acNo || !bank) {
      setBankStatusData((prevStatus) => ({
        ...prevStatus,
        "Platform ": "",
        Status: "",
        "Borrower Disbursement Bank Account No": "DETAILS NOT PROVIDED",
        "Borrower Disbursement Bank Account Name as Provided": "",
        "Borrower Name as per Bank Records ": "",
        "Borrower Disbursement Bank Name ": "",
        "Borrower Disbursement Bank Branch Name ": "",
        "Borrower Disbursement Bank IFSC Code ": "DETAILS NOT PROVIDED",
        "Checked On ": "",
      }));
    } else {
      try {
        const checkStatus = await axios.post(url + "/loan/fetchBankDetails", {
          email: EMAIL,
          token: TOKEN,
          custId: id,
          bankIfsc: ifsc,
          acNo: acNo
        });

        console.log(checkStatus.data);
        if (checkStatus.data.auth === true) {
          setBankStatusData((prevStatus) => ({
            ...prevStatus,
            "Platform ": checkStatus.data.message.platform ?? "",
            Status: checkStatus.data.message.message ?? "",
            "Borrower Disbursement Bank Account No":
              checkStatus.data.message.accNo ?? "",
            "Borrower Disbursement Bank Account Name as Provided":
              checkStatus.data.message.accHolderName ?? "",
            "Borrower Name as per Bank Records ":
              checkStatus.data.message.nameAsPerBank ?? "",
            "Borrower Disbursement Bank Name ":
              checkStatus.data.message.bankName ?? "",
            "Borrower Disbursement Bank Branch Name ":
              checkStatus.data.message.branchName ?? "",
            "Borrower Disbursement Bank IFSC Code ":
              checkStatus.data.message.ifsc ?? "",
            "Checked On ":
              formattedDate(checkStatus.data.message.checkedOn) ?? "",
          }));
        } else {
          // toast.error('Bank Data not fetched');
          setBankStatusData((prevStatus) => ({
            ...prevStatus,
            "Platform ": "",
            Status: "NOT YET VERIFIED",
            "Borrower Disbursement Bank Account No": acNo,
            "Borrower Disbursement Bank Account Name as Provided": "",
            "Borrower Name as per Bank Records ": "",
            "Borrower Disbursement Bank Name ": bank,
            "Borrower Disbursement Bank Branch Name ": "",
            "Borrower Disbursement Bank IFSC Code ": ifsc,
            "Checked On ": "",
          }));
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const fetchBankStatusCollection = async (id, ifsc, acNo, bank) => {
    console.log(id, ifsc, acNo, "aaaa");

    if (!id || !ifsc || !acNo || !bank) {
      setBankStatusDataCollection((prevStatus) => ({
        ...prevStatus,
        "Platform ": "",
        Status: "",
        "Borrower Collection Bank Account No": "DETAILS NOT PROVIDED",
        "Borrower Collection Bank Account Name as Provided": "",
        "Borrower Name as per Bank Records ": "",
        "Borrower Collection Bank Name ": "",
        "Borrower Collection Bank Branch Name ": "",
        "Borrower Collection Bank IFSC Code ": "DETAILS NOT PROVIDED",
        "Checked On ": "",
      }));
    } else {
      try {
        const checkStatus = await axios.post(url + "/loan/fetchBankDetails1", {
          email: EMAIL,
          token: TOKEN,
          custId: id,
          bankIfsc: ifsc,
          acNo: acNo,
        });

        // console.log(checkStatus.data);
        if (checkStatus.data.auth === true) {
          setBankStatusDataCollection((prevStatus) => ({
            ...prevStatus,
            "Platform ": checkStatus.data.message.platform ?? "",
            Status: checkStatus.data.message.message ?? "",
            "Borrower Collection Bank Account No":
              checkStatus.data.message.accNo ?? "",
            "Borrower Collection Bank Account Name as Provided":
              checkStatus.data.message.accHolderName ?? "",
            "Borrower Name as per Bank Records ":
              checkStatus.data.message.nameAsPerBank ?? "",
            "Borrower Collection Bank Name ":
              checkStatus.data.message.bankName ?? "",
            "Borrower Collection Bank Branch Name ":
              checkStatus.data.message.branchName ?? "",
            "Borrower Collection Bank IFSC Code ":
              checkStatus.data.message.ifsc ?? "",
            "Checked On ":
              formattedDate(checkStatus.data.message.checkedOn) ?? "",
          }));
        } else {
          // toast.error('Bank Data not fetched');
          setBankStatusDataCollection((prevStatus) => ({
            ...prevStatus,
            "Platform ": "",
            Status: "NOT YET VERIFIED",
            "Borrower Collection Bank Account No": acNo,
            "Borrower Collection Bank Account Name as Provided": "",
            "Borrower Name as per Bank Records ": "",
            "Borrower Collection Bank Name ": bank,
            "Borrower Collection Bank Branch Name ": "",
            "Borrower Collection Bank IFSC Code ": ifsc,
            "Checked On ": "",
          }));
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const fetchAadhaarStatus = async (id, dump) => {
    console.log(id);
    console.log(dump);

    if (!id) {
      setaadhaarStatusData((prevStatus) => ({
        ...prevStatus,
        "Verification Platform": "",
        "AADHAAR No (Encrypted/Masked) ": "AADHAAR NUMBER NOT PROVIDED",
        "Name ": "",
        "Address ": "",
        "Gender ": "",
        DOB: "",
        Status: "",
        photo_link: "",
      }));
    } else {
      setaadhaarStatusData((prevStatus) => ({
        ...prevStatus,
        "Verification Platform": dump?.name ? "CASHFREE" : "DIGILOCKER",
        "AADHAAR No (Encrypted/Masked) ": id,
        "Name ": dump?.name || dump?.actions?.[0]?.details?.aadhaar?.name,
        "Address ":
          dump?.address ||
          dump?.actions?.[0]?.details?.aadhaar?.current_address_details
            ?.address,
        "Gender ": dump?.gender || dump?.actions?.[0]?.details?.aadhaar?.gender,
        DOB: dump?.dob || dump?.actions?.[0]?.details?.aadhaar?.dob,
        Status: dump?.message || dump?.actions?.[0]?.status,
        photo_link:
          dump?.photo_link || dump?.actions?.[0]?.details?.aadhaar?.image,
      }));
    }
  };

  const fetchDlStatus = async (id, dob) => {
    console.log(id);
    console.log(dob);

    if (!id) {
      setDlStatusData((prevStatus) => ({
        ...prevStatus,
        "Verification Platform": "CASHFREE",
        "DL No. ": "NOT YET PROVIDED",
        "Status ": "",
        "Name ": "",
        DOB: "",
        "DL Issue Date ": "",
        "Vehicle Class ": "",
        "Valid Till ": "",
        "District ": "",
        "State ": "",
        "Checked On ": "",
      }));
    } else {
      try {
        const checkStatus = await axios.post(
          url + "/borrower/fetchDlVerification",
          {
            email: EMAIL,
            token: TOKEN,
            dlNo: id,
          }
        );
        console.log(checkStatus.data);
        if (checkStatus.data.auth === true) {
          setDlStatusData((prevStatus) => ({
            ...prevStatus,
            "Verification Platform": checkStatus.data.message.platform ?? "",
            "DL No. ": id,
            "Status ": checkStatus.data.message.status ?? "",
            "Name ": checkStatus.data.message.name ?? "",
            DOB: dob,
            "DL Issue Date ": checkStatus.data.message.issueDate ?? "",
            "Vehicle Class ": checkStatus.data.message.vehicleClass ?? "",
            "Valid Till ": checkStatus.data.message.validToNonTransport ?? "",
            "District ": checkStatus.data.message.districtName ?? "",
            "State ": checkStatus.data.message.stateName ?? "",
            "Checked On ":
              formattedDate(checkStatus.data.message.checkedOn) ?? "",
          }));
        } else {
          // toast.error('DL Data not fetched');
          setDlStatusData((prevStatus) => ({
            ...prevStatus,
            "Verification Platform": "",
            "DL No. ": id,
            "Status ": "",
            "Name ": "",
            DOB: dob,
            "DL Issue Date ": "",
            "Vehicle Class ": "",
            "Valid Till ": "",
            "District ": "",
            "State ": "",
            "Checked On ": "",
          }));
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleReverifyPan = async (id, dob, name, requestor) => {
    console.log(id, dob, name, requestor);
    if (id.length !== 10) return toast.error("Invalid PAN number");
    try {
      const checkStatus = await axios.post(url + "/borrower/reVerifyPan", {
        email: EMAIL,
        token: TOKEN,
        pan: id,
        dob: dob,
        name: name,
        requestor: requestor,
      });

      console.log(checkStatus.data);
      if (checkStatus.data.auth === true) {
        // setPanStatusData((prevStatus) => ({
        //     ...prevStatus,
        //     "Verification Platform": checkStatus.data.message.platform ?? "",
        //     "PAN ": checkStatus.data.message.panNumber ?? "",
        //     "Category ": checkStatus.data.message.category ?? "",
        //     "Name as per PAN match ": checkStatus.data.message.nameAsPerPanMatch ?? "",
        //     "Date of birth match ": checkStatus.data.message.panDobMatch ?? "",
        //     "Aadhaar Seeding Status ": checkStatus.data.message.aadharSeedingStatus ?? "",
        //     "PAN Card Document Status ": "",
        //     "Verified On ": checkStatus.data.message.checkedOn ?? "",
        // }));

        toast.success(checkStatus.data.message);
        fetchPanStatus(id);
        return;
      } else {
        // setPanStatusData((prevStatus) => ({
        //     ...prevStatus,
        //     "Verification Platform": checkStatus.data.message.platform ?? "",
        //     "PAN ": checkStatus.data.message.panNumber ?? "",
        //     "Category ": checkStatus.data.message.category ?? "",
        //     "Name as per PAN match ": checkStatus.data.message.nameAsPerPanMatch ?? "",
        //     "Date of birth match ": checkStatus.data.message.panDobMatch ?? "",
        //     "Aadhaar Seeding Status ": checkStatus.data.message.aadharSeedingStatus ?? "",
        //     "PAN Card Document Status ": "",
        //     "Verified On ": checkStatus.data.message.checkedOn ?? "",
        // }));

        toast.error(checkStatus.data.message);
        fetchPanStatus(id);
        return;
      }
    } catch (err) {
      console.log(err);
    }
  };

  /* Aadhaar digilocker flow started from July 2025
    const handleReverifyAadhaar = async (id, requestor, borrowerId) => {
        console.log(id);
        if (id.length !== 12 && id.length !== 32) return toast.error('Invalid AADHAAR number');
        setOpen(true);
        try {
            const checkStatus = await axios.post(url + '/lead/verifyAadhaar/sendOtp', {
                email: EMAIL,
                token: TOKEN,
                aadhaarNo: id,
                requestor: requestor
            })

            console.log(checkStatus.data);
            if (checkStatus.data.auth === 1) {
                
                setOpen(false);
                toast.error(checkStatus.data?.message?.message);
                fetchAadhaarStatus(id, checkStatus.data?.message);
                return;

            } else if (checkStatus.data.auth === true) {
                setOpen(false);
                toast.success("OTP Sent to registered mobile number");
                setTimeout(() => {
                    const otp = prompt("Please Enter OTP");
                    handleVerifyAadhaarOtp(otp, checkStatus.data.ref_id, requestor, borrowerId, id);
                    // setAadhaarOtp(otp)
                }, 4000);
            } else {
                setOpen(false);
                toast.error(checkStatus.data.message);
                return;
            }

        } catch(err) {
            setOpen(false);
            console.log(err);
            return;
        }
    }

    const handleVerifyAadhaarOtp = async (otp, refId, requestor, borrowerId, id) => {
        setOpen(true);
        try {
            const verifyOtp = await axios.post(url + "/borrower/verifyAadhaar/verifyOtp", {
                otp: otp,
                refId: refId,
                email: EMAIL,
                token: TOKEN,
                requestor: requestor,
                borrowerId: borrowerId
            })
            
            console.log(verifyOtp.data);
            if (verifyOtp.data.auth) {
                setOpen(false);
                fetchAadhaarStatus(id, verifyOtp.data.message);

            } else {
                toast.error("Invalid OTP Please Try Again");
                setOpen(false);
                return;
            }

        } catch (err) {
            console.log(err);
        }
    }
    */

  const handleReverifyVoter = async (id, requestor) => {
    console.log(id, requestor);
    try {
      const checkStatus = await axios.post(url + "/borrower/reVerifyVoterId", {
        email: EMAIL,
        token: TOKEN,
        voterId: id,
        requestor: requestor,
      });

      console.log(checkStatus.data);
      if (checkStatus.data.auth === true) {
        // setVoterIdStatusData((prevStatus) => ({
        //     ...prevStatus,
        //     "Verification Platform": checkStatus.data.message.platform ?? "",
        //     "VOTER ID ": checkStatus.data.message.epicNo ?? "",
        //     "Name ": checkStatus.data.message.name ?? "",
        //     "Polling Station Name ": checkStatus.data.message.pollingStationName ?? "",
        //     "Assembly Constituency Name ": checkStatus.data.message.assemblyConstituencyName ?? "",
        //     "District ": checkStatus.data.message.districtName ?? "",
        //     "State ": checkStatus.data.message.stateName ?? "",
        //     "Verified On ": formattedDate(checkStatus.data.message.checkedOn) ?? "",

        // }));

        toast.success(checkStatus.data.message);
        fetchVoterStatus(id);
        return;
      } else {
        // setVoterIdStatusData((prevStatus) => ({
        //     ...prevStatus,
        //     "Verification Platform": checkStatus.data.message.platform ?? "",
        //     "VOTER ID ": checkStatus.data.message.epicNo ?? "",
        //     "Name ": checkStatus.data.message.name ?? "",
        //     "Polling Station Name ": checkStatus.data.message.pollingStationName ?? "",
        //     "Assembly Constituency Name ": checkStatus.data.message.assemblyConstituencyName ?? "",
        //     "District ": checkStatus.data.message.districtName ?? "",
        //     "State ": checkStatus.data.message.stateName ?? "",
        //     "Verified On ": formattedDate(checkStatus.data.message.checkedOn) ?? "",

        // }));

        toast.error(checkStatus.data.message);
        fetchVoterStatus(id);
        return;
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleReverifyBank = async (
    accNo,
    ifsc,
    custId,
    bankName,
    accName,
    requestor
  ) => {
    console.log(accNo, ifsc, custId, requestor);
    try {
      const checkStatus = await axios.post(url + "/loan/reVerifyBank", {
        email: EMAIL,
        token: TOKEN,
        accNo: accNo,
        ifsc: ifsc,
        custId: custId,
        bankName: bankName,
        accName: accName,
        requestor: requestor,
      });

      console.log(checkStatus.data);
      if (checkStatus.data.auth === true) {
        toast.success(checkStatus.data.message);
        fetchBankStatus(custId, ifsc, accNo, bankName);
        fetchBankStatusCollection(custId, ifsc, accNo, bankName);
        return;
      } else {
        toast.error(checkStatus.data.message);
        fetchBankStatus(custId, ifsc, accNo, bankName);
        fetchBankStatusCollection(custId, ifsc, accNo, bankName);
        return;
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleReverifyDl = async (id, dob, requestor) => {
    console.log(id, requestor);
    try {
      const checkStatus = await axios.post(url + "/borrower/reVerifyDl", {
        email: EMAIL,
        token: TOKEN,
        dlNo: id,
        dob: dob,
        requestor: requestor,
      });

      console.log(checkStatus.data);
      if (checkStatus.data.auth === true) {
        toast.success(checkStatus.data.message);
        fetchDlStatus(id, dob);
        return;
      } else {
        toast.error(checkStatus.data.message);
        fetchDlStatus(id, dob);
        return;
      }
    } catch (err) {
      console.log(err);
    }
  };

  const downloadVoterDetails = async (id) => {
    if (!id) return toast.error("Voter ID is required");
    try {
      const fetchDetails = await axios.post(
        url + "/borrower/fetchVoterIdVerification",
        {
          voterId: id,
          email: EMAIL,
          token: TOKEN,
        }
      );
      console.log(fetchDetails.data);
      if (fetchDetails.data.auth === false) {
        toast.error(fetchDetails.data.message);
      } else {
        if (!fetchDetails.data.message.dump) {
          toast.error("Dump not found. Please reverify");
        } else {
          let details = fetchDetails.data.message.dump;

          // const formatNestedObject = (obj) => {
          //     return Object.entries(obj)
          //         .map(([key, value]) => `${key}: ${value}`)
          //         .join(', ');
          // };

          // const rows = Object.entries(details).map(([key, value]) => {
          //     if (typeof value === 'object' && value !== null) {
          //         return [key, formatNestedObject(value)];
          //     }
          //     return [key, value];
          // });

          const doc = new jsPDF();

          doc.setFont("Nirmala");
          doc.text(
            "Voter ID Verification Response for : " + details.name,
            25,
            20
          );

          doc.autoTable({
            head: [["Field", "Value"]],
            // body: rows,
            // body: [
            //     ['Name', details.name],
            //     ['Name in Regional Language', ''],
            //     ['Age', details.age],
            // ],
            body: [
              ["EPIC Number", details?.epic_number || details.epic_no],
              ["Name", details.name],
              ["Name in Regional Language", ""],
              ["Age", details.age],
              ["Relation Name", details?.relation_name || details.rln_name],
              ["Relation Name in Regional Language", ""],
              ["Relation Type", details?.relation_type || details.rln_type],
              ["Gender", details?.gender],
              ["State", details?.state || details.st_name],
              ["State in Regional Language", ""],
              [
                "Assembly Constituency Number",
                details?.assembly_constituency_number || details.ac_no,
              ],
              [
                "Assembly Constituency Name",
                details?.assembly_constituency || details.ac_name,
              ],
              ["AC Name in Regional Language", ""],
              [
                "Parliament Constituency Number",
                details?.parliamentary_constituency_number || details.pc_no,
              ],
              [
                "Parliament Constituency Name",
                details?.parliamentary_constituency || details.pc_name,
              ],
              ["Part Number", details?.part_number || details.part_no],
              ["Part Name", details?.part_name || details.part_name],
              [
                "Serial Number",
                details?.serial_number || details.details?.partSerialNumber,
              ],
              ["Polling Station", details?.polling_station || details.ps_name],
              [
                "Polling Address",
                details?.address || details.details?.buildingAddress,
              ],
            ],
            startY: 30,
            // columnStyles: {
            //     0: { cellWidth: 60 },
            //     1: { cellWidth: 'auto' },
            // },
            // didDrawCell: (data) => {
            //     if (data.row.raw[0] === 'Name in Regional Language' && data.column.index === 1) {
            //         doc.setFont("Nirmala");
            //         doc.text(details.name_in_regional_lang, data.cell.x + 2, data.cell.y + data.cell.height / 2 + 2);
            //     }
            // },
            didDrawCell: (data) => {
              const regionalFields = {
                "Name in Regional Language":
                  details?.name_in_regional_lang || details?.name_v1,
                "Relation Name in Regional Language":
                  details?.relation_name_in_regional_lang ||
                  details.rln_name_v1,
                "State in Regional Language":
                  details?.details?.stateNameL1 || "",
                "AC Name in Regional Language": details?.ac_name_v1 || "",
              };

              if (data.column.index === 1 && regionalFields[data.row.raw[0]]) {
                doc.setFont("Nirmala");
                doc.text(
                  regionalFields[data.row.raw[0]],
                  data.cell.x + 2,
                  data.cell.y + data.cell.height / 2 + 2
                );
              }
            },
          });

          doc.save("voter_details.pdf");
          toast.success("Details downloaded successfully!");
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const downloadAadhaarDetails = async (id, requestor, custId) => {
    if (!id || !requestor || !custId)
      return toast.error("Mandatory fields are required");
    try {
      const fetchDetails = await axios.post(
        url + "/borrower/fetchAadhaarDetails",
        {
          aadhaarNo: id,
          requestor: requestor,
          customerId: custId,
          email: EMAIL,
          token: TOKEN,
        }
      );
      console.log(fetchDetails.data);

      if (fetchDetails.data.auth === false) {
        toast.error(fetchDetails.data.message);
      } else {
        let details = fetchDetails.data.message;
        console.log(details);

        if (details.actions?.[0]?.status === "approved") {
          const fetch = await axios.post(url + "/borrower/getDigilockerDoc", {
            digioRID: details.actions?.[0]?.execution_request_id,
            docType: "pdf",
            email: EMAIL,
            token: TOKEN,
          });

          console.log(fetch.data);

          if (fetch.data.auth === true) {
            const linkSource = `data:application/pdf;base64,${fetch.data.message}`;
            const downloadLink = document.createElement("a");
            const fileName = `${custId}-AADHAAR.pdf`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();

            return;
          } else {
            toast.error(fetchDetails.data.message);
            return;
          }
        }

        const filteredDetails = { ...details };
        delete filteredDetails.photo_link;
        if (filteredDetails.share_code) {
          delete filteredDetails.share_code;
        }
        if (filteredDetails.xml_file) {
          delete filteredDetails.xml_file;
        }

        const first8Fields = [
          "ref_id",
          "status",
          "message",
          "name",
          "care_of",
          "dob",
          "gender",
          "year_of_birth",
        ]; // Prioritized fields

        const fieldMapping = {
          ref_id: "Reference ID",
          status: "Verification Status",
          message: "Verification Message",
          name: "Name",
          care_of: "Care Of",
          dob: "Date of Birth",
          gender: "Gender",
          year_of_birth: "Birth Year",
          address: "Full Address",
          split_address: "Split Address",
          email: "Email Hashed",
          mobile_hash: "Mobile Hashed",
        };

        const splitAddressFieldMapping = {
          country: "Country",
          state: "State",
          dist: "District",
          subdist: "Sub-District",
          vtc: "Village/Town/City",
          street: "Street",
          house: "House",
          landmark: "Landmark",
          pincode: "Pin Code",
        };

        const remainingFieldsOrder = [
          "address",
          "split_address-country",
          "split_address-state",
          "split_address-dist",
          "split_address-subdist",
          "split_address-vtc",
          "split_address-street",
          "split_address-house",
          "split_address-landmark",
          "split_address-pincode",
          "email",
          "mobile_hash",
        ];

        const first8Rows = first8Fields
          .filter((field) => field in filteredDetails)
          .map((field) => [
            fieldMapping[field] || field,
            filteredDetails[field],
            "",
          ]);

        const remainingRows = remainingFieldsOrder.flatMap((field) => {
          if (field.startsWith("split_address-")) {
            const nestedKey = field.split("-")[1];
            const nestedValue = filteredDetails.split_address?.[nestedKey];
            if (nestedValue !== undefined) {
              return [
                [splitAddressFieldMapping[nestedKey] || nestedKey, nestedValue],
              ];
            }
          } else if (filteredDetails[field] !== undefined) {
            return [[fieldMapping[field] || field, filteredDetails[field]]];
          }
          return [];
        });

        const doc = new jsPDF();

        doc.setFont("Nirmala");
        doc.text(
          "Aadhaar Verification Response for : " + filteredDetails.name,
          25,
          20
        );

        // Generate table

        doc.autoTable({
          head: [["Field", "Value"]],
          body: first8Rows,
          startY: 30,
          columnStyles: {
            0: { cellWidth: 50 },
            1: { cellWidth: 80 },
            2: { cellWidth: "auto" },
          },
        });

        const photoLink = details.photo_link;

        if (photoLink) {
          const startX = 150;
          const startY = 40;
          const tableHeight = 10 * Math.min(5, first8Rows.length);
          const photoWidth = 40;
          const photoHeight = tableHeight;

          doc.addImage(
            photoLink,
            "JPEG",
            startX,
            startY,
            photoWidth,
            photoHeight
          );
        }

        doc.autoTable({
          // head: [['Field', 'Value']],
          body: remainingRows,
          startY: doc.autoTable.previous.finalY + 2,
          columnStyles: {
            0: { cellWidth: 50 },
            1: { cellWidth: "auto" },
          },
        });

        doc.save("aadhaar_details.pdf");
        toast.success("Details downloaded successfully!");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const downloadAadhaarXml = async (id, requestor, custId) => {
    if (!id || !requestor || !custId)
      return toast.error("Mandatory fields are required");
    try {
      console.log(id, requestor, custId);

      const fetch = await axios.post(url + "/borrower/fetchAadhaarDetails", {
        aadhaarNo: id,
        requestor: requestor,
        customerId: custId,
        email: EMAIL,
        token: TOKEN,
      });
      console.log(fetch.data);

      if (fetch.data.auth === false) {
        toast.error(fetch.data.message);
      }

      let dump = fetch.data.message;

      if (dump.actions?.[0]?.status === "approved") {
        const fetch1 = await axios.post(url + "/borrower/getDigilockerDoc", {
          digioRID: dump.actions?.[0]?.execution_request_id,
          docType: "xml",
          email: EMAIL,
          token: TOKEN,
        });

        console.log(fetch1.data);
        if (fetch1.data.auth === true) {
          const blob = new Blob([fetch1.data.message], {
            type: "application/xml",
          });
          const url1 = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url1;
          a.download = `${custId}_aadhaar.xml`;
          a.click();

          URL.revokeObjectURL(url1);
          return;
        } else {
          toast.error(fetch1.data.message);
          return;
        }
      }

      const fetchDetails = await axios.post(url + "/borrower/fetchAadhaarXml", {
        aadhaarNo: id,
        requestor: requestor,
        customerId: custId,
        email: EMAIL,
        token: TOKEN,
      });

      console.log(fetchDetails.data);

      if (fetchDetails.data.auth === false) {
        return toast.error("Aadhaar XML not found");
      }

      const blob = new Blob([fetchDetails.data], { type: "application/xml" });
      const url1 = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url1;
      a.download = `${custId}_aadhaar.xml`;
      a.click();

      URL.revokeObjectURL(url1);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDecryptClick = async (value, requestor) => {
    console.log(value);
    console.log(requestor);

    try {
      const decrypt = await axios.post(url + "/borrower/decryptAadhaar", {
        email: EMAIL,
        token: TOKEN,
        id: value,
        requestor: requestor,
      });

      console.log(decrypt.data);
      if (decrypt.data.auth === true) {
        toast.success("Decrypted");
        setInfoData(decrypt.data.message);
        return;
      } else {
        toast.error(decrypt.data.message);
        return;
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (EMAIL === "rupesh.bishnoi@credin.in") {
      setvisible(true);
      axios
        .post(url + "/user/getsingle", {
          token: TOKEN,
          email: EMAIL,
          useremail: EMAIL,
        })
        .then((res) => {
          setSourcePhone(res.data[0].staff_mobile);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: TOKEN,
          email: EMAIL,
          useremail: EMAIL,
        })
        .then((res) => {
          // console.log(res);
          setDecryptButtonVisible(res.data[0].permission.decrypt_aadhaar);
          setSourcePhone(res.data[0].staff_mobile);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [TOKEN, EMAIL]);

  useEffect(() => {
    console.log(loan, 'loan');
    // let borrower_name = borrowerData.borrower?.borrower_firstname + " " + borrowerData.borrower?.borrower_middlename + " " + borrowerData.borrower?.borrower_lastname;
    let borrower_panno = borrowerData.borrower?.borrower_panno;
    let borrower_dob = borrowerData.borrower?.borrower_dob;
    let borrower_voterid = borrowerData.borrower?.borrower_voter_no;
    let borrower_id = borrowerData.borrower?.borrower_uniqueno;
    // let borrower_accNo = borrowerData.borrower?.borrower_disbursement_bank_account;
    // let borrower_ifsc = borrowerData.borrower?.borrower_disbursement_bank_ifsc;
    // let borrower_bank = borrowerData.borrower?.borrower_disbursement_bank_name;
    // let borrower_collection_accNo = borrowerData.borrower?.borrower_collection_bank_account;
    // let borrower_collection_ifsc = borrowerData.borrower?.borrower_collection_bank_ifsc;
    // let borrower_collection_bank = borrowerData.borrower?.borrower_collection_bank_name;

    let borrower_name = loan?.borrower_name;
    let borrower_accNo = loan?.collection_bank_account_number;
    let beneficiary_name = loan?.collection_beneficiary_name;
    let borrower_ifsc = loan?.collection_bank_ifsc;
    let borrower_bank = loan?.collection_bank_name;
    let borrower_collection_accNo = loan?.disbursement_bank_account_number;
    let beneficiary_name_collection = loan?.disbursement_beneficiary_name;
    let borrower_collection_ifsc = loan?.disbursement_bank_ifsc;
    let borrower_collection_bank = loan?.disbursement_bank_name;

    let borrower_aadhaar = borrowerData.borrower?.borrower_aadharno;
    let borrower_aadhaar_dump = borrowerData.borrower?.borrower_aadhaar_dump;

    let borrower_dl = borrowerData.borrower?.borrower_driving_license_no;

    let temp = parseInt(activeTab.slice(5));
    // console.log(temp, activeTab)
    // let coapplicant_name = borrowerData.coapplicant[temp-1]?.coapplicant_name;
    // let coapplicant_pan = borrowerData.coapplicant[temp-1]?.coapplicant_panno;
    // let coapplicant_dob = borrowerData.coapplicant[temp-1]?.coapplicant_dob;
    // let coapplicant_voterid = borrowerData.coapplicant[temp-1]?.coapplicant_voterno;
    // let coapplicant_id = borrowerData.coapplicant[temp-1]?.coapplicant_id;
    // let coapplicant_accNo = borrowerData.coapplicant[temp-1]?.coapplicant_bank_account;
    // let coapplicant_ifsc = borrowerData.coapplicant[temp-1]?.coapplicant_bank_ifsc;
    // let coapplicant_bank = borrowerData.coapplicant[temp-1]?.coapplicant_bank_name;

    // changes done because of loan wise filtering
    console.log(filteredCoapplicants);
    let coapplicant_name = filteredCoapplicants[temp - 1]?.coapplicant_name;
    let coapplicant_pan = filteredCoapplicants[temp - 1]?.coapplicant_panno;
    let coapplicant_dob = filteredCoapplicants[temp - 1]?.coapplicant_dob;
    let coapplicant_voterid =
      filteredCoapplicants[temp - 1]?.coapplicant_voterno;
    let coapplicant_id = filteredCoapplicants[temp - 1]?.coapplicant_id;
    let coapplicant_accNo =
      filteredCoapplicants[temp - 1]?.coapplicant_bank_account;
    let coapplicant_ifsc =
      filteredCoapplicants[temp - 1]?.coapplicant_bank_ifsc;
    let coapplicant_bank =
      filteredCoapplicants[temp - 1]?.coapplicant_bank_name;

    // let coapplicant_aadhaar = borrowerData.coapplicant[temp-1]?.coapplicant_aadharno;
    // let coapplicant_aadhaar_dump = borrowerData.coapplicant[temp-1]?.borrower_aadhaar_dump;
    let coapplicant_aadhaar =
      filteredCoapplicants[temp - 1]?.coapplicant_aadharno;
    let coapplicant_aadhaar_dump =
      filteredCoapplicants[temp - 1]?.borrower_aadhaar_dump;

    if (activeTab === "App") {
      setRequestor("kycBorrower");
      setPanNo(borrower_panno);
      setName(borrower_name);
      setDob(borrower_dob);
      fetchPanStatus(borrower_panno, borrower_dob, borrower_name);

      setAadhaarNo(borrower_aadhaar);
      fetchAadhaarStatus(borrower_aadhaar, borrower_aadhaar_dump);

      setVoterId(borrower_voterid);
      fetchVoterStatus(borrower_voterid);

      setCustomerId(borrower_id);
      setCustomerLoanId(loanID);
      setBankAccNo(borrower_accNo);
      setBeneficiaryName(beneficiary_name);
      setBankIfsc(borrower_ifsc);
      setBankName(borrower_bank);
      fetchBankStatus(loanID, borrower_ifsc, borrower_accNo, borrower_bank);

      setBankAccNoCollection(borrower_collection_accNo);
      setBeneficiaryNameCollection(beneficiary_name_collection);
      setBankIfscCollection(borrower_collection_ifsc);
      setBankNameCollection(borrower_collection_bank);
      fetchBankStatusCollection(
        loanID,
        borrower_collection_ifsc,
        borrower_collection_accNo,
        borrower_collection_bank
      );
      console.log(borrower_collection_bank);

      setDlNo(borrower_dl);
      fetchDlStatus(borrower_dl, borrower_dob);
      setInfoData("");
    } else if (activeTab === "Coapp1") {
      setRequestor("kycCoborrower");
      setPanNo(coapplicant_pan);
      setName(coapplicant_name);
      setDob(coapplicant_dob);
      fetchPanStatus(coapplicant_pan, coapplicant_dob, coapplicant_name);

      setAadhaarNo(coapplicant_aadhaar);
      fetchAadhaarStatus(coapplicant_aadhaar, coapplicant_aadhaar_dump);

      setVoterId(coapplicant_voterid);
      fetchVoterStatus(coapplicant_voterid);

      setCustomerId(coapplicant_id);
      setBankAccNo(coapplicant_accNo);
      setBankIfsc(coapplicant_ifsc);
      setBankName(coapplicant_bank);
      fetchBankStatus(coapplicant_id, coapplicant_ifsc);
      setInfoData("");
    } else if (activeTab === "Coapp2") {
      setRequestor("kycCoborrower");
      setPanNo(coapplicant_pan);
      setName(coapplicant_name);
      setDob(coapplicant_dob);
      fetchPanStatus(coapplicant_pan, coapplicant_dob, coapplicant_name);

      setAadhaarNo(coapplicant_aadhaar);
      fetchAadhaarStatus(coapplicant_aadhaar, coapplicant_aadhaar_dump);

      setVoterId(coapplicant_voterid);
      fetchVoterStatus(coapplicant_voterid);

      setCustomerId(coapplicant_id);
      setBankAccNo(coapplicant_accNo);
      setBankIfsc(coapplicant_ifsc);
      setBankName(coapplicant_bank);
      fetchBankStatus(coapplicant_id, coapplicant_ifsc);
      setInfoData("");
    } else if (activeTab === "Coapp3") {
      setRequestor("kycCoborrower");
      setPanNo(coapplicant_pan);
      setName(coapplicant_name);
      setDob(coapplicant_dob);
      fetchPanStatus(coapplicant_pan, coapplicant_dob, coapplicant_name);

      setAadhaarNo(coapplicant_aadhaar);
      fetchAadhaarStatus(coapplicant_aadhaar, coapplicant_aadhaar_dump);

      setVoterId(coapplicant_voterid);
      fetchVoterStatus(coapplicant_voterid);

      setCustomerId(coapplicant_id);
      setBankAccNo(coapplicant_accNo);
      setBankIfsc(coapplicant_ifsc);
      setBankName(coapplicant_bank);
      fetchBankStatus(coapplicant_id, coapplicant_ifsc);
      setInfoData("");
    } else if (activeTab === "Coapp4") {
      setRequestor("kycCoborrower");
      setPanNo(coapplicant_pan);
      setName(coapplicant_name);
      setDob(coapplicant_dob);
      fetchPanStatus(coapplicant_pan, coapplicant_dob, coapplicant_name);

      setAadhaarNo(coapplicant_aadhaar);
      fetchAadhaarStatus(coapplicant_aadhaar, coapplicant_aadhaar_dump);

      setVoterId(coapplicant_voterid);
      fetchVoterStatus(coapplicant_voterid);
      setCustomerId(coapplicant_id);
      setBankAccNo(coapplicant_accNo);
      setBankIfsc(coapplicant_ifsc);
      setBankName(coapplicant_bank);
      fetchBankStatus(coapplicant_id, coapplicant_ifsc);
      setInfoData("");
    }
    //eslint-disable-next-line
  }, [borrowerData, activeTab, activeAccountType]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app.digio.in/sdk/v11/digio.js"; // prod
    // script.src = "https://ext-gateway.digio.in/sdk/v11/digio.js"; // stag
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : false);
  };

  const handleAccountTypeChange = (type) => {
    setActiveAccountType(type);
  };

  const handleDigioAadhaar = async (id, requestor, borrowerId) => {
    if (id.length !== 12 && id.length !== 32)
      return toast.error("Invalid Aadhaar number..");

    if (!window.Digio) {
      alert("Digio SDK is not loaded yet.");
      return;
    }

    setOpen(true);

    const fetchID = await axios.post(url + `/borrower/getID`, {
      phone: sourcePhone,
    });
    console.log(fetchID.data);

    if (fetchID.data.auth !== true) {
      alert("Please try again");
      setOpen(false);
      return;
    }

    const options = {
      environment: "production",
      // environment: "sandbox",

      callback: async function (response) {
        if (response?.error_code) {
          console.error("Digio Error:", response.message);
          toast.error("Aadhaar authentication failed");
          setOpen(false);
        } else {
          console.log("Digio Success:", response);

          const fetchData = await axios.post(url + `/borrower/getDigiAadhaar`, {
            id: response.digio_doc_id,
          });

          console.log(fetchData.data);
          if (fetchData.data.auth === true) {
            const updateDB = await axios.post(
              url + `/borrower/verifyScreen/AadhaarSave`,
              {
                email: EMAIL,
                token: TOKEN,
                requestor: requestor,
                borrowerId: borrowerId,
                aadhaarDump: fetchData.data.message,
              }
            );
            console.log(updateDB.data);
            setOpen(false);
            fetchAadhaarStatus(id, fetchData.data.message);
          } else {
            toast.error("Aadhaar Details not fetched");
            setOpen(false);
          }
        }
      },

      event_listener: function (event) {
        console.log("Digio Event:", event);

        if (event?.payload?.data) {
          const kycData = event.payload.data;
          console.log("KYC Data:", kycData);
        }

        if (event?.payload?.error) {
          console.error("Digio Error Event:", event.payload.error);
        }
      },

      // logo: "https://yourcompany.com/logo.png", // Optional
      theme: {
        primaryColor: "#0055FF",
        secondaryColor: "#000000",
      },
    };

    const digio = new window.Digio(options);
    digio.init();
    digio.submit(
      fetchID.data.message.id,
      fetchID.data.message.customer_identifier
    );
  };

  const renderTabContent = (value) => {
    return (
      <div>
        <Accordion
          expanded={expandedAccordion === "PANpanel"}
          onChange={handleAccordionChange("PANpanel")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <strong>PAN</strong>
          </AccordionSummary>
          <AccordionDetails>
            {/* <Button sx={{ background: "rgb(3, 78, 161)", color: "white"}} onClick={() => handleReverifyPan(panNo, dob, name)}>REVERIFY</Button> */}
            <button
              className={styles.verifyButton}
              onClick={() => handleReverifyPan(panNo, dob, name, requestor)}
              disabled={isDisbursed}
            >
              REVERIFY
            </button>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ padding: "9px" }}>
                      <strong>Field</strong>
                    </TableCell>
                    <TableCell sx={{ padding: "9px" }}>
                      <strong>Value</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                {/*<TableBody>
                                    {Object.entries(panStatusData).map(([key, value]) => (
                                        <TableRow key={key}>
                                            <TableCell sx={{ padding: '9px' }}>{key.replace(/_/g, ' ')}</TableCell>
                                            <TableCell sx={{ padding: '9px' }}>{value.toString()}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>*/}
                <TableBody>
                  {Object.entries(panStatusData).map(([key, value]) => {
                    const isAadhaarPanLinkFalse =
                      key.trim() === "Aadhaar PAN Link Status" &&
                      value?.toString().toLowerCase() === "false";

                    return (
                      <TableRow key={key}>
                        <TableCell
                          sx={{
                            padding: "9px",
                            color: isAadhaarPanLinkFalse ? "red" : "inherit",
                            fontWeight: isAadhaarPanLinkFalse
                              ? "bold"
                              : "normal",
                          }}
                        >
                          {key.replace(/_/g, " ")}
                        </TableCell>

                        <TableCell
                          sx={{
                            padding: "9px",
                            color: isAadhaarPanLinkFalse ? "red" : "inherit",
                            fontWeight: isAadhaarPanLinkFalse
                              ? "bold"
                              : "normal",
                          }}
                        >
                          {value.toString()}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expandedAccordion === "AADHAARpanel"}
          onChange={handleAccordionChange("AADHAARpanel")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <strong>AADHAAR</strong>
          </AccordionSummary>
          <AccordionDetails>
            {/*<button className={styles.verifyButton} disabled="true" onClick={() => handleReverifyAadhaar(aadhaarNo, requestor, customerId)}>REVERIFY</button>*/}
            <button
              className={styles.verifyButton}
              onClick={() =>
                handleDigioAadhaar(aadhaarNo, requestor, customerId)
              }
              disabled={isDisbursed}
            >
              REVERIFY
            </button>
            <button
              className={styles.verifyButton}
              style={{ marginLeft: "5px" }}
              onClick={() =>
                downloadAadhaarDetails(aadhaarNo, requestor, customerId)
              }
            >
              DOWNLOAD PDF
            </button>
            <button
              className={styles.verifyButton}
              style={{ marginLeft: "5px" }}
              onClick={() =>
                downloadAadhaarXml(aadhaarNo, requestor, customerId)
              }
            >
              DOWNLOAD XML
            </button>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ padding: "9px" }}>
                      <strong>Field</strong>
                    </TableCell>
                    <TableCell sx={{ padding: "9px" }}>
                      <strong>Value</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.entries(aadhaarStatusData).map(
                    ([key, value]) =>
                      // Remove the photo_link else it will break my page width
                      // key !== "photo_link" && (
                      // Remove the fields: photo_link, share_code, and xml_file
                      key !== "photo_link" &&
                      key !== "share_code" &&
                      key !== "xml_file" && (
                        <TableRow key={key}>
                          <TableCell sx={{ padding: "9px" }}>
                            {key.replace(/_/g, " ")}
                          </TableCell>
                          {/* <TableCell sx={{ padding: '9px' }}>{value}</TableCell> */}
                          <TableCell sx={{ padding: "9px" }}>
                            {key === "AADHAAR No (Encrypted/Masked) " &&
                            value !== "AADHAAR NUMBER NOT PROVIDED" &&
                            value.length > 20 ? (
                              <>
                                <span>{value}</span>
                                {(decryptButtonVisible || visible) && (
                                  <button
                                    style={{
                                      marginLeft: "20px",
                                      background: "rgb(3,78,161)",
                                      color: "rgb(255,255,255)",
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                      border: "none",
                                      padding: "3px 10px",
                                    }}
                                    onClick={() =>
                                      handleDecryptClick(value, requestor)
                                    }
                                  >
                                    Decrypt
                                  </button>
                                )}

                                {infoData && (
                                  <span style={{ marginLeft: "20px" }}>
                                    {infoData}
                                  </span>
                                )}
                              </>
                            ) : (
                              value
                            )}
                          </TableCell>
                        </TableRow>
                      )
                  )}
                  {aadhaarStatusData.photo_link && (
                    <TableRow>
                      <TableCell sx={{ padding: "9px" }}>Photo</TableCell>
                      <TableCell sx={{ padding: "9px" }}>
                        <img
                          src={
                            aadhaarStatusData.photo_link.startsWith(
                              "data:image/"
                            )
                              ? aadhaarStatusData.photo_link
                              : `data:image/jpeg;base64,${aadhaarStatusData.photo_link}`
                          }
                          alt="Aadhaar"
                          style={{
                            width: "150px",
                            height: "auto",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expandedAccordion === "VIDpanel"}
          onChange={handleAccordionChange("VIDpanel")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <strong>VOTER ID</strong>
          </AccordionSummary>
          <AccordionDetails>
            {/* <Button sx={{ background: "rgb(3, 78, 161)", color: "white"}} onClick={() => handleReverifyVoter(voterId)}>REVERIFY</Button> */}
            <button
              className={styles.verifyButton}
              onClick={() => handleReverifyVoter(voterId, requestor)}
              disabled={isDisbursed}
            >
              REVERIFY
            </button>
            <button
              className={styles.verifyButton}
              style={{ marginLeft: "5px" }}
              onClick={() => downloadVoterDetails(voterId)}
            >
              DOWNLOAD
            </button>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ padding: "9px" }}>
                      <strong>Field</strong>
                    </TableCell>
                    <TableCell sx={{ padding: "9px" }}>
                      <strong>Value</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.entries(voterIdStatusData).map(([key, value]) => (
                    <TableRow key={key}>
                      <TableCell sx={{ padding: "9px" }}>
                        {key.replace(/_/g, " ")}
                      </TableCell>
                      <TableCell sx={{ padding: "9px" }}>
                        {value.toString()}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expandedAccordion === "DLpanel"}
          onChange={handleAccordionChange("DLpanel")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <strong>DRIVING LICENSE</strong>
          </AccordionSummary>
          <AccordionDetails>
            <button
              className={styles.verifyButton}
              onClick={() => handleReverifyDl(dlNo, dob, requestor)}
              disabled={isDisbursed}
            >
              REVERIFY
            </button>
            {/* <button className={styles.verifyButton} style={{marginLeft: "5px"}} onClick={() => downloadVoterDetails(voterId)}>DOWNLOAD</button> */}
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ padding: "9px" }}>
                      <strong>Field</strong>
                    </TableCell>
                    <TableCell sx={{ padding: "9px" }}>
                      <strong>Value</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.entries(dlStatusData).map(([key, value]) => (
                    <TableRow key={key}>
                      <TableCell sx={{ padding: "9px" }}>
                        {key.replace(/_/g, " ")}
                      </TableCell>
                      <TableCell sx={{ padding: "9px" }}>
                        {value.toString()}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expandedAccordion === "BANKpanel"}
          onChange={handleAccordionChange("BANKpanel")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <strong>BANK</strong>
          </AccordionSummary>
          <AccordionDetails>
            {activeTab === "App" ? (
              <div style={{ marginBottom: "16px" }}>
                <Button
                  variant={
                    activeAccountType === "DISBURSEMENT"
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => handleAccountTypeChange("DISBURSEMENT")}
                  sx={{ marginRight: "8px" }}
                >
                  {bankAccNo === bankAccNoCollection
                    ? "Disbursement cum Collection Account"
                    : "Collection Account"}
                </Button>

                {bankAccNo !== bankAccNoCollection && (
                  <Button
                    variant={
                      activeAccountType === "COLLECTION"
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() => handleAccountTypeChange("COLLECTION")}
                  >
                    Disbursement Account
                  </Button>
                )}
              </div>
            ) : null}

            {/* <Button sx={{ background: "rgb(3, 78, 161)", color: "white"}} onClick={() => handleReverifyBank(bankAccNo, bankIfsc, customerId, bankName, name)}>REVERIFY</Button> */}

            {activeTab === "App" ? (
              <button
                className={styles.verifyButton}
                disabled={isDisbursed}
                onClick={() =>
                  activeAccountType === "DISBURSEMENT"
                    ? handleReverifyBank(
                        bankAccNo,
                        bankIfsc,
                        customerLoanId,
                        bankName,
                        beneficiaryName,
                        requestor
                      )
                    : handleReverifyBank(
                        bankAccNoCollection,
                        bankIfscCollection,
                        customerLoanId,
                        bankNameCollection,
                        beneficiaryNameCollection,
                        requestor
                      )
                }
              >
                REVERIFY
              </button>
            ) : (
              <button
                className={styles.verifyButton}
                onClick={() =>
                  handleReverifyBank(
                    bankAccNo,
                    bankIfsc,
                    customerLoanId,
                    bankName,
                    beneficiaryName,
                    requestor
                  )
                }
              >
                REVERIFY
              </button>
            )}

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ padding: "9px" }}>
                      <strong>Field</strong>
                    </TableCell>
                    <TableCell sx={{ padding: "9px" }}>
                      <strong>Value</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* {Object.entries(bankStatusData).map(([key, value]) => ( */}
                  {Object.entries(
                    activeAccountType === "DISBURSEMENT"
                      ? bankStatusData
                      : bankStatusDataCollection
                  ).map(([key, value]) => (
                    <TableRow key={key}>
                      <TableCell sx={{ padding: "9px" }}>
                        {key.replace(/_/g, " ")}
                      </TableCell>
                      <TableCell sx={{ padding: "9px" }}>
                        {value.toString()}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      </div>
    );
  };

  const formattedDate = (date) => {
    let formatDate;
    if (date) {
      const dateObj = new Date(date);
      const day = dateObj.getUTCDate().toString().padStart(2, "0");
      const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
      const year = dateObj.getUTCFullYear();
      // const hours = dateObj.getUTCHours().toString().padStart(2, '0');
      // const minutes = dateObj.getUTCMinutes().toString().padStart(2, '0');
      // const seconds = dateObj.getUTCSeconds().toString().padStart(2, '0');
      // formatDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      formatDate = `${day}-${month}-${year}`;
    }
    return formatDate;
  };

  // const handleLoanIDChange = (e) => {
  //     setLoanID(e.target.value);
  //     setActiveTab("App");
  // };

  return (
    <>
      <ToastContainer />

      <hr className="hori-line" />

      {loanID && (
        <div>
          <button
            className={styles.addhoverButton}
            onClick={() => setActiveTab("App")}
            style={{
              backgroundColor: activeTab === "App" ? "#034ea1" : "#eef7ff",
              color: activeTab === "App" ? "white" : "gray",
            }}
          >
            Applicant
          </button>

          {numberOfCoapplicants > 0 && (
            <button
              className={styles.addhoverButton}
              onClick={() => setActiveTab("Coapp1")}
              style={{
                backgroundColor: activeTab === "Coapp1" ? "#034ea1" : "#eef7ff",
                color: activeTab === "Coapp1" ? "white" : "gray",
              }}
            >
              Co-Applicant 1
            </button>
          )}

          {numberOfCoapplicants > 1 && (
            <button
              className={styles.addhoverButton}
              onClick={() => setActiveTab("Coapp2")}
              style={{
                backgroundColor: activeTab === "Coapp2" ? "#034ea1" : "#eef7ff",
                color: activeTab === "Coapp2" ? "white" : "gray",
              }}
            >
              Co-Applicant 2
            </button>
          )}

          {numberOfCoapplicants > 2 && (
            <button
              className={styles.addhoverButton}
              onClick={() => setActiveTab("Coapp3")}
              style={{
                backgroundColor: activeTab === "Coapp3" ? "#034ea1" : "#eef7ff",
                color: activeTab === "Coapp3" ? "white" : "gray",
              }}
            >
              Co-Applicant 3
            </button>
          )}

          {numberOfCoapplicants > 3 && (
            <button
              className={styles.addhoverButton}
              onClick={() => setActiveTab("Coapp4")}
              style={{
                backgroundColor: activeTab === "Coapp4" ? "#034ea1" : "#eef7ff",
                color: activeTab === "Coapp4" ? "white" : "gray",
              }}
            >
              Co-Applicant 4
            </button>
          )}
        </div>
      )}

      <div>{loanID && renderTabContent(activeTab)}</div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default VerificationNew;
